// extracted by mini-css-extract-plugin
export default {"stickySave":"ModelRouting_stickySave__9jtCT","stickyFilters":"ModelRouting_stickyFilters__ibXv3"};